<!-- ÜGYFÉLVÁLASZTÁS – a NAPLO belépési pontja: amíg nincs kiválasztott ügyfél, semmi más nem nyílik meg. -->
<div class="n-oldalfej">
  <div>
    <h2>Ügyfélválasztás</h2>
    <span class="n-alcim">Válaszd ki, kinek a könyvelésével dolgozol</span>
  </div>
  <div class="spacer"></div>
  <label class="ev-valaszto">Könyvelési év
    <select [ngModel]="aktiv.ev" (ngModelChange)="evValt(+$event)">
      <option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option>
    </select>
  </label>
  <ion-button fill="outline" style="--color:#fff;--border-color:rgba(255,255,255,.6)" *ngIf="szerkeszthet && berElerheto" (click)="importNyit()"
              title="A bérszámfejtésben már rögzített cég átvétele könyvelési ügyfélnek (és összekötése)">
    <ion-icon slot="start" name="download-outline"></ion-icon> Átvétel a Bérből
  </ion-button>
  <ion-button (click)="uj()" *ngIf="szerkeszthet">
    <ion-icon slot="start" name="add"></ion-icon> Új ügyfél
  </ion-button>
</div>

<div *ngIf="ugyfelek.length" class="ugyfel-szuro">
  <ion-searchbar class="szuro-nev" [(ngModel)]="szuroNev" debounce="150" placeholder="Név / azonosító" [animated]="true"></ion-searchbar>
  <ion-searchbar class="szuro-ado" [(ngModel)]="szuroAdoszam" debounce="150" placeholder="Adószám" inputmode="numeric"></ion-searchbar>
  <ion-select class="szuro-forma" [(ngModel)]="szuroForma" interface="popover" placeholder="Adózási forma" [interfaceOptions]="{ cssClass: 'wide-popover' }">
    <ion-select-option value="">Minden adózási forma</ion-select-option>
    <ion-select-option value="kettos">Kettős könyvvitel</ion-select-option>
    <ion-select-option value="egyszeres">Egyszeres (tételes SZJA)</ion-select-option>
    <ion-select-option value="kata">KATA</ion-select-option>
    <ion-select-option value="atalany">Átalányadó</ion-select-option>
  </ion-select>
  <ion-button fill="clear" size="small" (click)="szuroTorol()" *ngIf="szuroNev || szuroAdoszam || szuroForma">
    <ion-icon slot="start" name="close-circle-outline"></ion-icon>Szűrő törlése
  </ion-button>
  <span class="szuro-db">{{ szurtUgyfelek.length }} / {{ ugyfelek.length }}</span>
  <!-- Nézet: csempék vagy tömör lista – a választást a böngésző megjegyzi. -->
  <div class="nezet-valto" role="group" aria-label="Nézet">
    <button type="button" [class.aktiv]="nezet === 'csempe'" (click)="nezetValt('csempe')" title="Csempék"><ion-icon name="grid-outline"></ion-icon></button>
    <button type="button" [class.aktiv]="nezet === 'lista'" (click)="nezetValt('lista')" title="Lista"><ion-icon name="list-outline"></ion-icon></button>
  </div>
</div>

<div *ngIf="!ugyfelek.length" class="ures">
  <ion-icon name="business-outline"></ion-icon>
  Még nincs könyvelt ügyfél. Vegyen fel egyet az „Új ügyfél” gombbal.
</div>

<div *ngIf="ugyfelek.length && !szurtUgyfelek.length" class="ures">
  <ion-icon name="search-outline"></ion-icon>
  Nincs a szűrőnek megfelelő ügyfél.
</div>

<!-- LISTA NÉZET – sok ügyfélnél áttekinthetőbb; a sorra kattintva ugyanúgy belép. -->
<div class="ugyfel-lista" *ngIf="nezet === 'lista' && szurtUgyfelek.length">
  <table>
    <thead><tr><th>Azonosító</th><th>Név</th><th>Adószám</th><th>Könyvelés</th><th>Cím</th><th>Jellemzők</th><th>Kapcsolatok</th><th></th></tr></thead>
    <tbody>
      <tr *ngFor="let u of szurtUgyfelek" [class.aktiv]="u.id === aktiv.ugyfelId" [class.inaktiv]="u.inaktiv" (click)="belep(u)" [title]="'Megnyitás: ' + u.nev">
        <td class="azon">{{ u.azonosito }}</td>
        <td class="nev">{{ u.nev }}</td>
        <td>{{ u.adoszam }}</td>
        <td><span class="mod-cimke" [class.kettos]="u.konyveles_mod === 'kettos'">{{ u.konyveles_mod === 'kettos' ? 'Kettős' : 'Egyszeres' }}</span></td>
        <td class="cim">{{ u.irsz }} {{ u.telepules }}{{ u.cim ? ', ' + u.cim : '' }}</td>
        <td class="cimkek">
          <span class="cimke zold" *ngIf="u.afa_alany">ÁFA</span><span class="cimke" *ngIf="u.alapitvany">Alapítvány</span>
          <span class="cimke lila" *ngIf="u.tipus === 'tarsashaz'">Társasház</span><span class="cimke" *ngIf="u.deviza">Devizás</span><span class="cimke" *ngIf="+u.futar_mod" title="Futár mód: a Wolt / foodora számlák magától bekerülnek">Futár</span>
          <span class="cimke sarga" *ngIf="u.kata">KATA</span><span class="cimke sarga" *ngIf="u.atalanyado && u.konyveles_mod !== 'kettos'">Átalány</span><span class="cimke sarga" *ngIf="u.alanyi_mentes && !u.afa_alany">AAM</span>
        </td>
        <td class="integracio-ikonok">
          <ion-icon name="receipt-outline" [class.aktiv]="u.van_osa" title="NAV Online Számla (OSA)"></ion-icon>
          <ion-icon name="server-outline" [class.aktiv]="u.van_m2m" title="NAV M2M / adófolyószámla"></ion-icon>
          <ion-icon name="key-outline" [class.aktiv]="u.van_ugyfelkapu" [class.hiba]="u.ugyfelkapu_hiba" [title]="u.ugyfelkapu_hiba ? kauHibaCim(u) : 'Ügyfélkapu+ fiók'"></ion-icon>
          <ion-icon name="card-outline" [class.aktiv]="u.van_bank" title="Bankszinkron"></ion-icon>
          <button type="button" class="kau-hiba-jel" *ngIf="u.ugyfelkapu_hiba" [title]="kauHibaCim(u)" (click)="$event.stopPropagation(); kauHibaNyit()">
            <ion-icon name="warning"></ion-icon> Teendő: {{ u.ugyfelkapu_hiba.kinek === 'ugyfel' ? 'ügyfél' : 'könyvelő' }}
          </button>
        </td>
        <td class="muv" (click)="$event.stopPropagation()">
          <button type="button" (click)="szerkeszt(u)" *ngIf="szerkeszthet" title="Ügyfél adatai"><ion-icon name="create-outline"></ion-icon></button>
          <button type="button" (click)="modulokNyit(u)" *ngIf="vanModulKapcsolo" title="Modulok (Gépjármű, Készlet, Számla és Kassza, Tárgyi eszköz ki/be)"><ion-icon name="apps-outline"></ion-icon></button>
          <button type="button" class="ber" title="Bérszámfejtés" (click)="atvaltBer(u)" *ngIf="berElerheto"><ion-icon name="cash-outline"></ion-icon></button>
          <button type="button" class="torol" (click)="torol(u)" *ngIf="szerkeszthet" title="Törlés"><ion-icon name="trash-outline"></ion-icon></button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="naplo-grid" *ngIf="nezet === 'csempe'">
  <div class="ugyfel-tile" *ngFor="let u of szurtUgyfelek" [class.aktiv]="u.id === aktiv.ugyfelId" [class.inaktiv]="u.inaktiv"
       [class.kettos]="u.konyveles_mod === 'kettos'" [class.egyszeres]="u.konyveles_mod !== 'kettos'" (click)="belep(u)"
       [title]="'Megnyitás: ' + u.nev">
    <span class="mod-cimke">{{ u.konyveles_mod === 'kettos' ? 'Kettős' : 'Egyszeres' }}</span>
    <span class="azon">{{ u.azonosito }}</span>
    <div class="nev">{{ u.nev }}</div>
    <div class="meta">
      <span *ngIf="u.adoszam">Adószám: {{ u.adoszam }}<br></span>
      <span *ngIf="u.telepules">{{ u.irsz }} {{ u.telepules }}, {{ u.cim }}</span>
    </div>
    <div class="meta cimkek">
      <span class="cimke zold" *ngIf="u.afa_alany">ÁFA-alany</span>
      <span class="cimke" *ngIf="u.alapitvany">Alapítvány</span>
      <span class="cimke lila" *ngIf="u.tipus === 'tarsashaz'">Társasház</span><span class="cimke" *ngIf="+u.futar_mod">Futár</span>
      <span class="cimke" *ngIf="u.deviza">Devizás</span>
      <span class="cimke sarga" *ngIf="u.kata">KATA</span>
      <span class="cimke sarga" *ngIf="u.atalanyado && u.konyveles_mod !== 'kettos'">Átalány</span>
      <span class="cimke sarga" *ngIf="u.alanyi_mentes && !u.afa_alany">AAM</span>
    </div>
    <!--  Sikertelen Ügyfélkapu-belépés: a fiók lekérései szünetelnek, amíg valaki nem javítja – a kártyán
          kiírjuk, kinek a dolga (könyvelő: a tárolt adat rossz; ügyfél: a KAÜ-fiókja zárolt / lejárt). -->
    <div class="kau-hiba" *ngIf="u.ugyfelkapu_hiba" [class.ugyfel]="u.ugyfelkapu_hiba.kinek === 'ugyfel'" [title]="kauHibaCim(u)"
         (click)="$event.stopPropagation(); kauHibaNyit()">
      <ion-icon name="warning"></ion-icon>
      <div>
        <b>Ügyfélkapu-belépés sikertelen – a szinkron szünetel</b>
        <span>{{ u.ugyfelkapu_hiba.kinek === 'ugyfel'
          ? 'Teendő: ügyfél – oldja fel / újítsa meg az Ügyfélkapu-fiókját.'
          : 'Teendő: könyvelő – javítsa a belépési adatokat (jelszó / TOTP).' }}</span>
      </div>
    </div>
    <div class="tile-lab">
      <!-- Integráció-státusz: színes = beállítva/aktív, szürke = hiányzik (hol kell még beállítani) -->
      <div class="integracio-ikonok">
        <ion-icon name="receipt-outline" [class.aktiv]="u.van_osa" title="NAV Online Számla (OSA){{ u.van_osa ? ' – beállítva' : ' – nincs beállítva' }}"></ion-icon>
        <ion-icon name="server-outline" [class.aktiv]="u.van_m2m" title="NAV M2M / adófolyószámla{{ u.van_m2m ? ' – beállítva' : ' – nincs beállítva' }}"></ion-icon>
        <ion-icon name="key-outline" [class.aktiv]="u.van_ugyfelkapu" [class.hiba]="u.ugyfelkapu_hiba"
                  [title]="u.ugyfelkapu_hiba ? kauHibaCim(u) : 'Ügyfélkapu+ fiók' + (u.van_ugyfelkapu ? ' – hozzárendelve' : ' – nincs hozzárendelve')"></ion-icon>
        <ion-icon name="card-outline" [class.aktiv]="u.van_bank" title="Bankszinkron{{ u.van_bank ? ' – aktív' : ' – nincs/lejárt' }}"></ion-icon>
      </div>
      <div class="tile-muvelet" (click)="$event.stopPropagation()">
        <button type="button" (click)="szerkeszt(u)" *ngIf="szerkeszthet" title="Ügyfél adatai"><ion-icon name="create-outline"></ion-icon></button>
        <button type="button" (click)="modulokNyit(u)" *ngIf="vanModulKapcsolo" title="Modulok (Gépjármű, Készlet, Számla és Kassza, Tárgyi eszköz ki/be)"><ion-icon name="apps-outline"></ion-icon></button>
        <button type="button" class="ber" title="Bérszámfejtés" (click)="atvaltBer(u)" *ngIf="berElerheto"><ion-icon name="cash-outline"></ion-icon></button>
        <button type="button" class="torol" (click)="torol(u)" *ngIf="szerkeszthet" title="Törlés"><ion-icon name="trash-outline"></ion-icon></button>
      </div>
    </div>
  </div>
</div>

<ion-modal #ugyfelModal class="naplo-wide-modal" (didDismiss)="zarEngedd()">
  <ng-template>
    <ion-header><ion-toolbar class="naplo-toolbar" style="--background:var(--naplo); --color:#fff">
      <ion-title>{{ szerk?.id ? 'Ügyfél módosítása' : 'Új ügyfél' }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="ugyfelModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="szerk">
     <app-szerk-zar-sav [zar]="zarUgyfel"></app-szerk-zar-sav>
     <div class="ua">
      <!-- ═══ ALAPADATOK (az RLB ügyféllapjának rendjében) ═══ -->
      <section class="ua-kartya">
        <div class="ua-racs">
          <label class="ua-m"><span>Azonosító *</span><input [(ngModel)]="szerk.azonosito" [disabled]="!!szerk.id" maxlength="4" placeholder="pl. ZEN"></label>
          <label class="ua-jel"><input type="checkbox" [(ngModel)]="szerk.inaktiv"> Inaktív</label>
          <label class="ua-m"><span>Vállalkozás kezdete</span><input type="date" [(ngModel)]="szerk.vallalkozas_kezdete"></label>
          <label class="ua-m ua-sz3"><span>Név *</span><input [(ngModel)]="szerk.nev" placeholder="Vállalkozás / szervezet neve"></label>
          <label class="ua-m"><span>Cégforma</span>
            <select [(ngModel)]="szerk.cegforma"><option [ngValue]="null">– a névből becsülve –</option>
              <option *ngFor="let f of cegformak" [ngValue]="f.k">{{ f.n }}</option></select></label>
          <label class="ua-m"><span>Adószám</span>
            <span class="ua-egyutt"><input [(ngModel)]="szerk.adoszam" placeholder="12345678-1-12" (blur)="navAdozo(false)">
              <button type="button" class="ua-eu" [disabled]="navFut || navTorzs(szerk.adoszam).length !== 8" (click)="navAdozo(true)"
                      title="Név, teljes adószám, székhely és cégforma a NAV-tól (az iroda technikai felhasználójával)"><span>{{ navFut ? '…' : 'NAV' }}</span></button></span>
            <small class="ua-vies-ered" *ngIf="navUzenet" [class.jo]="navUzenet.ok" [class.rossz]="!navUzenet.ok">{{ navUzenet.szoveg }}</small></label>
          <label class="ua-m"><span>Csoportos adószám</span><input [(ngModel)]="szerk.csoportos_adoszam"></label>
          <label class="ua-m ua-vies"><span>Közösségi adószám</span>
            <span class="ua-egyutt"><input [(ngModel)]="szerk.koz_adoszam" placeholder="HU12345678">
              <button type="button" class="ua-eu" [disabled]="viesFut || !(szerk.koz_adoszam || szerk.adoszam)" (click)="viesEllenoriz()"
                      title="Ellenőrzés az EU VIES rendszerében (díjmentes) – üresen az adószámból képzi"><span>EU</span></button></span>
            <small class="ua-vies-ered" *ngIf="vies" [class.jo]="vies.ok && vies.ervenyes" [class.rossz]="!vies.ok || !vies.ervenyes">
              {{ vies.ok ? (vies.ervenyes ? '✓ érvényes' : '✗ nem érvényes') : vies.hiba }}<ng-container *ngIf="vies.nev"> · {{ vies.nev }}</ng-container>
              <ng-container *ngIf="vies.cim"> · {{ vies.cim }}</ng-container></small></label>
          <label class="ua-m"><span>Ügyvezető</span><input [(ngModel)]="szerk.ugyvezeto"></label>
          <label class="ua-m"><span>Kapcsolattartó</span><input [(ngModel)]="szerk.kapcsolat"></label>
          <label class="ua-m"><span>E-mail</span><input type="email" [(ngModel)]="szerk.email"></label>
          <label class="ua-m"><span>Telefon</span><input [(ngModel)]="szerk.telefon"></label>
          <label class="ua-m"><span>Fax</span><input [(ngModel)]="szerk.fax"></label>
          <label class="ua-m ua-sz2"><span>Bankszámla</span><input [(ngModel)]="szerk.bankszamla"></label>
        </div>
      </section>

      <!-- ═══ HA EGYÉNI VÁLLALKOZÓ ═══ -->
      <section class="ua-kartya" *ngIf="egyeni">
        <h4>{{ szerk.tipus === 'ingatlan' ? 'A magánszemély adatai (a bérlő cég 08-asához is)' : 'Ha egyéni vállalkozó' }}</h4>
        <div class="ua-racs">
          <label class="ua-m ua-sz3"><span>Születési név</span><input [(ngModel)]="szerk.szuletesi_nev"></label>
          <label class="ua-m"><span>Előtag</span>
            <select [(ngModel)]="szerk.nev_elotag"><option [ngValue]="null"></option><option *ngFor="let e of ['Dr.', 'ifj.', 'id.', 'özv.']" [ngValue]="e">{{ e }}</option></select></label>
          <label class="ua-m"><span>Vezetéknév</span><input [(ngModel)]="szerk.vezeteknev"></label>
          <label class="ua-m"><span>Utónév</span><input [(ngModel)]="szerk.utonev"></label>
          <label class="ua-m ua-sz2"><span>Anyja neve</span><input [(ngModel)]="szerk.anyja_neve"></label>
          <label class="ua-m"><span>Adóazonosító jel</span><input [(ngModel)]="szerk.adoazonosito" maxlength="10"></label>
          <label class="ua-m ua-sz2"><span>Születési hely</span><input [(ngModel)]="szerk.szul_hely"></label>
          <label class="ua-m"><span>Születési idő</span><input type="date" [(ngModel)]="szerk.szul_ido"></label>
          <label class="ua-m"><span>EV nyilvántartási szám</span><input [(ngModel)]="szerk.ev_nyilv_szam"></label>
          <label class="ua-m"><span>TAJ szám</span><input [(ngModel)]="szerk.taj" maxlength="11"></label>
          <label class="ua-jel ua-sz2" title="Saját jogú nyugdíjas egyéni vállalkozó: a járulékai a 08-asba mennek, nem az 58-asba">
            <input type="checkbox" [(ngModel)]="szerk.kiegeszito"> Kiegészítő tevékenységű (nyugdíjas)</label>
        </div>
      </section>

      <!-- ═══ ADÓZÁS – ebből dönti el a munkaterv, milyen bevallás kell ═══ -->
      <section class="ua-kartya">
        <h4>Adózás és könyvelés</h4>
        <div class="ua-szegmensek">
          <div class="ua-szegmens"><span>Könyvelés módja</span>
            <button type="button" [class.aktiv]="szerk.konyveles_mod !== 'kettos'" (click)="szerk.konyveles_mod = 'egyszeres'">Egyszeres (naplófőkönyv)</button>
            <button type="button" [class.aktiv]="szerk.konyveles_mod === 'kettos'" (click)="szerk.konyveles_mod = 'kettos'">Kettős könyvvitel</button></div>
          <div class="ua-szegmens"><span>Ügyfél típusa</span>
            <button type="button" [class.aktiv]="!szerk.tipus || szerk.tipus === 'ceg'" (click)="szerk.tipus = 'ceg'">Cég / vállalkozás</button>
            <button type="button" [class.aktiv]="szerk.tipus === 'tarsashaz'" (click)="szerk.tipus = 'tarsashaz'">Társasház</button>
            <button type="button" [class.aktiv]="szerk.tipus === 'ingatlan'" (click)="szerk.tipus = 'ingatlan'; szerk.afa_alany = !!szerk.adoszam && szerk.afa_alany"
                    title="Magánszemély, aki ingatlant ad bérbe (adószámmal vagy anélkül) – megnyílik az Ingatlan-bérbeadás képernyő">Magánszemély bérbeadó</button></div>
        </div>
        <div class="ua-jelolok">
          <label class="ua-jel"><input type="checkbox" [(ngModel)]="szerk.afa_alany"> ÁFA-alany</label>
          <label class="ua-jel" *ngIf="!szerk.afa_alany" title="Áfa tv. 188. §: az éves bevétel értékhatárát (2026: 20 M Ft, 2027: 22 M Ft, 2028: 24 M Ft) a Könyvelés képernyő tetején figyeljük">
            <input type="checkbox" [(ngModel)]="szerk.alanyi_mentes"> Alanyi adómentes (AAM)</label>
          <label class="ua-m ua-afa" *ngIf="szerk.afa_alany"
                 [title]="szerk.afa_gyak_nav ? 'A NAV-törzsadat szerint: ' + szerk.afa_gyak_nav.szoveg + ' – ezért nem módosítható' : ''"><span>ÁFA-bevallás{{ szerk.afa_gyak_nav ? ' (NAV)' : '' }}</span>
            <select [(ngModel)]="szerk.afa_gyakorisag" [disabled]="!!szerk.afa_gyak_nav"><option [ngValue]="null">– nincs megadva –</option>
              <option ngValue="havi">havi</option><option ngValue="negyedeves">negyedéves</option><option ngValue="eves">éves</option></select></label>
          <label class="ua-jel"><input type="checkbox" [(ngModel)]="szerk.penzforgalmi_afa"> Pénzforgalmi ÁFA</label>
          <label class="ua-jel" *ngIf="szerk.konyveles_mod !== 'kettos'"><input type="checkbox" [(ngModel)]="szerk.kiegy_szamla"> Kiegyenlítetlen számlák kezelése</label>
          <label class="ua-jel"><input type="checkbox" [(ngModel)]="szerk.mezog_felar"> Mezőgazdasági kompenzációs felár</label>
          <label class="ua-jel" *ngIf="szerk.konyveles_mod !== 'kettos'"><input type="checkbox" [(ngModel)]="szerk.atalanyado"> Átalányadó</label>
          <label class="ua-jel" *ngIf="szerk.konyveles_mod !== 'kettos'"><input type="checkbox" [(ngModel)]="szerk.kata"> KATA-alany</label>
          <label class="ua-jel" title="Bérszámfejtésnél 10% KIVA a 13% szocho helyett; a munkaterv negyedéves KIVA-bevallást kér, TAO-t nem">
            <input type="checkbox" [(ngModel)]="szerk.kivas"> KIVA-alany</label>
          <label class="ua-jel"><input type="checkbox" [(ngModel)]="szerk.deviza"> Devizás</label>
          <label class="ua-jel" *ngIf="szerk.tipus !== 'tarsashaz' && szerk.tipus !== 'ingatlan'" title="Wolt / foodora futár (egyéni vállalkozó): a platform a futár nevében állítja ki a számlát és beküldi a NAV-nak – bekapcsolva 15 percenként lekérjük és a naplóba könyveljük">
            <input type="checkbox" [(ngModel)]="szerk.futar_mod"> Futár mód (Wolt / foodora)</label>
          <label class="ua-jel" *ngIf="szerk.konyveles_mod !== 'kettos'"><input type="checkbox" [(ngModel)]="szerk.alapitvany"> Alapítvány (oszlopfejlécek)</label>
          <label class="ua-jel" *ngIf="szerk.konyveles_mod !== 'kettos'" title="Bankszámlák, banki szinkron, kontírozás és bank napló. Kettős könyvvitelnél mindig jár.">
            <input type="checkbox" [(ngModel)]="szerk.bank_naplo"> Bank használata</label>
          <label class="ua-m" *ngIf="(szerk.konyveles_mod !== 'kettos' && (szerk.kata || szerk.atalanyado)) || (!szerk.afa_alany && szerk.alanyi_mentes)"><span>Éves bevételi keret (Ft)</span>
            <input type="number" [(ngModel)]="szerk.keret" placeholder="alapértelmezett"></label>
        </div>
        <app-futar-panel *ngIf="szerk.futar_mod && szerk.id" [ugyfelId]="szerk.id"></app-futar-panel>
        <p class="ua-munkaterv" *ngIf="munkatervElonezet.length"><b>A munkaterv szerint:</b> {{ munkatervElonezet.join(' · ') }}</p>
      </section>

      <!-- ═══ SZÉKHELY / TELEPHELY ═══ -->
      <section class="ua-kartya ua-ket">
        <div>
          <h4>Székhely</h4>
          <div class="ua-racs ua-cim">
            <label class="ua-m"><span>Irsz.</span><input [(ngModel)]="szerk.irsz" maxlength="10"></label>
            <label class="ua-m ua-sz2"><span>Település</span><input [(ngModel)]="szerk.telepules"></label>
            <label class="ua-m ua-sz3"><span>Cím (közterület, házszám, emelet, ajtó)</span><input [(ngModel)]="szerk.cim"></label>
          </div>
        </div>
        <div>
          <h4>Telephely</h4>
          <div class="ua-racs ua-cim">
            <label class="ua-m"><span>Irsz.</span><input [(ngModel)]="szerk.telephely_irsz" maxlength="10"></label>
            <label class="ua-m ua-sz2"><span>Település</span><input [(ngModel)]="szerk.telephely_telepules"></label>
            <label class="ua-m ua-sz3"><span>Cím</span><input [(ngModel)]="szerk.telephely_cim"></label>
          </div>
        </div>
      </section>

      <!-- ═══ EGYÉB ═══ -->
      <section class="ua-kartya">
        <h4>Egyéb</h4>
        <div class="ua-racs">
          <label class="ua-m"><span>TB törzsszám</span><input [(ngModel)]="szerk.tb_torzsszam"></label>
          <label class="ua-m"><span>KSH szám</span><input [(ngModel)]="szerk.ksh_szam"></label>
          <label class="ua-jel ua-sz2" title="Kikapcsolva a rövid cégnév jelenik meg (ha van)"><input type="checkbox" [(ngModel)]="szerk.partner_teljes_nev"> Teljes partnernevek a könyvelésben</label>
          <label class="ua-m ua-sz4"><span>Megjegyzés</span><input [(ngModel)]="szerk.megjegyzes" maxlength="255"></label>
        </div>
        <div class="ua-gombok" *ngIf="szerk.id">
          <button type="button" class="ov-gomb" (click)="osaBeallitas()" title="A NAV Online Számla technikai felhasználója (Törzsadatok)">
            <ion-icon name="key-outline"></ion-icon>Online számla beállítások</button>
        </div>
      </section>

      <!-- ═══ KAPCSOLATOK: ugyanaz a cég a Bérben, a SULINFORM-ban és az Iktatóban ═══ -->
      <section class="ua-kartya" *ngIf="szerk.id">
        <h4>Kapcsolatok – ugyanaz a cég máshol</h4>
        <div class="halvany" *ngIf="!kapcsolat">Betöltés…</div>
        <ng-container *ngIf="kapcsolat">
          <div class="ua-kapcs">
            <div class="ua-kapcs-sor">
              <span class="ua-kapcs-cim">Bérszámfejtési ügyfél</span>
              <div class="ua-kapcs-ertek">
                <select [(ngModel)]="kapcsolat.valasztott.ber_ugyfel_id">
                  <option value="">— nincs összekötve —</option>
                  <option *ngFor="let b of kapcsolat.berLista" [value]="b.id">{{ b.megjelenites_nev || b.nev }}{{ b.adoszam ? ' · ' + b.adoszam : '' }}</option>
                </select>
                <small class="ua-sugo">Összekötve elég egy helyen beállítani a NAV M2M-kapcsolatot, és a cég nyomtatványai mindkét alrendszerben látszanak.</small>
              </div>
            </div>
            <div class="ua-kapcs-sor" *ngIf="kapcsolat.feladatellatasok?.length">
              <span class="ua-kapcs-cim">SULINFORM intézmény</span>
              <div class="ua-kapcs-ertek">
                <select [(ngModel)]="kapcsolat.valasztott.sulinform_feladatellatas">
                  <option value="">— nincs —</option>
                  <option *ngFor="let f of kapcsolat.feladatellatasok" [value]="f.id">{{ f.name }} ({{ f.id }})</option>
                </select>
              </div>
            </div>
            <div class="ua-kapcs-sor" *ngIf="kapcsolat.valasztott.sulinform_feladatellatas">
              <span class="ua-kapcs-cim">Támogatási bankszámla</span>
              <div class="ua-kapcs-ertek">
                <select [(ngModel)]="kapcsolat.valasztott.tandij_bank_id">
                  <option value="">— nincs támogatási egyenleg —</option>
                  <option *ngFor="let b of kapcsolat.bankok" [value]="b.id">{{ b.bank_nev || 'Bankszámla' }} · {{ b.iban }}</option>
                </select>
                <small class="ua-sugo">Az erre a számlára érkező jóváírásokból számol a SULINFORM Pénzügy → Támogatás fül: a szülők a saját egyenlegüket látják, a bankpartnereket ott lehet családokhoz rendelni.{{ kapcsolat.bankok?.length ? '' : ' Ennek az ügyfélnek még nincs szinkronizált bankszámlája.' }}</small>
              </div>
            </div>
            <!--  Ha az iskola MÁSIK installáción van: kapcsolati kóddal (kapcsolat.js); a számlák onnan jönnek. -->
            <div class="ua-kapcs-sor">
              <span class="ua-kapcs-cim">SULINFORM másik rendszerből</span>
              <div class="ua-kapcs-ertek">
                <app-kapcsolat-valaszto [vegpont]="'/api/naplo-kapcsolat/' + szerk.id"></app-kapcsolat-valaszto>
              </div>
            </div>
            <div class="ua-kapcs-sor">
              <span class="ua-kapcs-cim">Az iskola bizonylatai</span>
              <div class="ua-kapcs-ertek">
                <button type="button" class="ov-gomb" (click)="szamlakNyit()"><ion-icon name="receipt-outline"></ion-icon>SULINFORM-számlák PDF-fel</button>
                <small class="ua-sugo">A kiállított számlák, díjbekérők és sztornók – a helyi SULINFORM-intézményből vagy a kapcsolaton át.</small>
              </div>
            </div>
            <!--  Ügyfélportál: a cég munkatársai olvashatják a saját könyvelésüket, bérüket (ugyfelportal.js). -->
            <div class="ua-kapcs-sor">
              <span class="ua-kapcs-cim">Ügyfélportál (a cég olvashatja)</span>
              <div class="ua-kapcs-ertek">
                <div *ngFor="let k of portal || []" class="ua-egyutt" style="gap:8px">
                  <span>{{ k.viselt_vez }} {{ k.viselt_ker }} <small class="ua-sugo">{{ k.felhasznalo }}{{ k.email ? ' · ' + k.email : '' }}</small></span>
                  <button type="button" class="ov-link" (click)="portalTorol(k)">elvétel</button>
                </div>
                <span class="ua-egyutt" style="gap:8px">
                  <input [(ngModel)]="portalUj" placeholder="felhasználó azonosítója vagy e-mail címe" style="min-width:240px">
                  <button type="button" class="ov-gomb" (click)="portalAd()" [disabled]="!portalUj.trim()">Hozzáférés</button>
                </span>
                <small class="ua-sugo" *ngIf="portalHiba" style="color:#b42318">{{ portalHiba }}</small>
                <small class="ua-sugo">A megadott felhasználó a Könyvelésbe lépve a cég eredményét, nyitott tételeit, adóit, bevallásait és bérösszesítőjét látja – csak olvasásra.
                  Ha a cég másik rendszeren dolgozik, az Admin → Kapcsolatok oldalon adj neki „Könyvelés” / „Bérszámfejtés” adatkörű kapcsolati kódot.</small>
              </div>
            </div>
            <!--  A cég saját Számla és Kassza- és készletadata (olvasás): helyben, vagy kapcsolati kóddal másik installációról. -->
            <div class="ua-kapcs-sor">
              <span class="ua-kapcs-cim">A cég számlázása és készlete</span>
              <div class="ua-kapcs-ertek">
                <span class="ua-egyutt" style="flex-wrap:wrap;gap:8px">
                  <button type="button" class="ov-gomb" (click)="szamlakNyit('szamlazo')"><ion-icon name="cash-outline"></ion-icon>Számla és Kassza bizonylatai</button>
                  <button type="button" class="ov-gomb" (click)="keszletNyit()"><ion-icon name="cube-outline"></ion-icon>Készlet</button>
                </span>
                <small class="ua-sugo">A cég által a Számla és Kasszában kiállított számlák, nyugták (PDF-fel) és a Készletkezelés készlete – olvasásra.
                  Ha a cég másik rendszeren dolgozik, a kapcsolati kódban ezeknek az adatköröknek is szerepelniük kell.</small>
              </div>
            </div>
            <div class="ua-kapcs-sor">
              <span class="ua-kapcs-cim">Iktató (intézmény)</span>
              <div class="ua-kapcs-ertek">
                <select [(ngModel)]="kapcsolat.valasztott.iktato_intezmeny" (ngModelChange)="kapcsolat.valasztott.iktato_konyv = ''">
                  <option value="">— nincs iktatás —</option>
                  <option *ngFor="let i of kapcsolat.iktatok" [value]="i.intezmeny">{{ i.nev || i.intezmeny }}{{ i.konyv_db ? ' · ' + i.konyv_db + ' iktatókönyv' : ' · még nincs iktatókönyv' }}</option>
                </select>
                <small class="ua-sugo">Ide iktat a rendszer, ha a Könyvelésből vagy a Bérből iktatsz – az iratkezelés szabályai az Iktatgatóéi.</small>
              </div>
            </div>
            <div class="ua-kapcs-sor ua-kapcs-al" *ngIf="kapcsolat.valasztott.iktato_intezmeny">
              <span class="ua-kapcs-cim">Iktatókönyv</span>
              <div class="ua-kapcs-ertek">
                <select [(ngModel)]="kapcsolat.valasztott.iktato_konyv">
                  <option value="">— válassz —</option>
                  <option *ngFor="let k of iktatoKonyvek" [value]="k.id">{{ k.nev }}{{ k.ev ? ' · ' + k.ev : '' }}{{ k.jel ? ' (' + k.jel + ')' : '' }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="ua-gombok">
            <button type="button" class="ov-gomb" [disabled]="kapcsolatMent || zarTilt" (click)="kapcsolatMentes()">
              <ion-icon name="link-outline"></ion-icon>Kapcsolatok mentése</button>
          </div>
        </ng-container>
      </section>

      <div class="ua-lab">
        <button type="button" class="ov-gomb" (click)="ugyfelModal.dismiss()">Mégse</button>
        <button type="button" class="ov-gomb fo" [disabled]="zarTilt" (click)="mentes()"><ion-icon name="save-outline"></ion-icon>Mentés</button>
      </div>
     </div>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- CÉG ÁTVÉTELE A BÉRBŐL: a bérszámfejtésben már rögzített foglalkoztatókból könyvelési ügyfél -->
<ion-modal #importModal cssClass="ber-urlap-modal ber-szeles-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Átvétel a Bérből</ion-title>
      <ion-buttons slot="end"><ion-button (click)="importModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form">
        <p class="halvany" style="margin:0">A kijelölt cégekből könyvelési ügyfél lesz, és rögtön összekötjük a bér-ügyféllel.
          Ha az adószám alapján már van ilyen könyvelési ügyfél, nem hozunk létre újat – csak összekötjük.</p>
        <div class="tabla-wrap" style="margin:0;max-height:55vh;overflow:auto">
          <table class="n-racs">
            <thead><tr><th></th><th>Cég</th><th>Adószám</th><th>Település</th><th>Állapot</th></tr></thead>
            <tbody>
              <tr *ngFor="let b of berUgyfelek">
                <td><input type="checkbox" [disabled]="b.osszekotve" [(ngModel)]="importValasztott[b.id]"></td>
                <td>{{ b.megjelenites_nev || b.nev }}</td>
                <td>{{ b.adoszam || '—' }}</td>
                <td>{{ b.telepules || '' }}</td>
                <td><span class="cimke zold" *ngIf="b.osszekotve">már összekötve</span></td>
              </tr>
              <tr *ngIf="!berUgyfelek.length"><td colspan="5" class="halvany">A bérszámfejtésben nincs cég ennél az intézménynél.</td></tr>
            </tbody>
          </table>
        </div>
        <div class="nk-lab"><button type="button" class="ov-gomb fo" (click)="importMent()"><ion-icon name="download-outline"></ion-icon>Átvétel</button></div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- Az iskola (SULINFORM) bizonylatai – helyben vagy kapcsolaton át (naplo-kapcsolat.js). -->
<ion-modal [isOpen]="!!szamlaNezet" (didDismiss)="szamlaNezet = null" class="naplo-wide-modal">
  <ng-template>
    <ion-header><ion-toolbar class="naplo-toolbar" style="--background:var(--naplo); --color:#fff">
      <ion-title>{{ szamlaNezet?.forras === 'szamlazo' ? 'Számla és Kassza bizonylatai' : 'SULINFORM-számlák' }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="szamlaNezet = null">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="szamlaNezet as n">
      <div class="szn-szuro">
        <label>Ettől <input type="date" [(ngModel)]="n.tol"></label>
        <label>Eddig <input type="date" [(ngModel)]="n.ig"></label>
        <button type="button" class="ov-gomb" (click)="szamlakBetolt()" [disabled]="n.fut">{{ n.fut ? 'Lekérés…' : 'Lekérés' }}</button>
        <span class="halvany" *ngIf="n.lista">{{ n.lista.length }} bizonylat · {{ szamlaOsszeg(n.lista) | number:'1.0-0' }} Ft
          {{ n.forras?.tavoli ? '· kapcsolaton át' : '· helyben' }}</span>
      </div>
      <div class="szn-figy" *ngFor="let f of n.figyelmeztetes || []">{{ f }}</div>
      <div class="szn-hiba" *ngIf="n.hiba">{{ n.hiba }}</div>
      <table class="szn-tabla" *ngIf="n.lista?.length">
        <thead><tr><th>Kelt</th><th>Sorszám</th><th>Típus</th><th>Vevő</th><th class="j">Összeg</th><th>NAV</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let s of n.lista" [class.storno]="s.sztornozva || s.tipus === 8">
            <td>{{ s.kelt }}</td><td class="szam">{{ s.szamlaszam }}</td><td>{{ s.tipus_nev }}</td>
            <td>{{ s.vevo }}<small *ngIf="s.vevo_adoszam"> · {{ s.vevo_adoszam }}</small></td>
            <td class="j">{{ s.osszeg | number:'1.0-0' }} Ft</td>
            <td>{{ s.nav_bekuldve ? '✓' : '' }}</td>
            <td><button type="button" class="szn-pdf" (click)="szamlaPdf(s)" title="PDF megnyitása">PDF</button></td>
          </tr>
        </tbody>
      </table>
      <div class="halvany" *ngIf="n.lista && !n.lista.length">Ebben az időszakban nincs bizonylat.</div>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- A cég készlete (Készletkezelés) – helyben vagy kapcsolaton át (naplo-kapcsolat.js). -->
<ion-modal [isOpen]="!!keszletNezet" (didDismiss)="keszletNezet = null" class="naplo-wide-modal">
  <ng-template>
    <ion-header><ion-toolbar class="naplo-toolbar" style="--background:var(--naplo); --color:#fff">
      <ion-title>Készlet{{ keszletNezet?.forras?.nev ? ' – ' + keszletNezet.forras.nev : '' }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="keszletNezet = null">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="keszletNezet as n">
      <div class="szn-szuro">
        <button type="button" class="ov-gomb" [class.masodlagos]="n.ful !== 'keszlet'" (click)="n.ful = 'keszlet'; keszletBetolt()">Készlet ma</button>
        <button type="button" class="ov-gomb" [class.masodlagos]="n.ful !== 'mozgas'" (click)="n.ful = 'mozgas'; keszletBetolt()">Mozgások</button>
        <ng-container *ngIf="n.ful === 'keszlet'">
          <input type="search" [(ngModel)]="n.kereso" placeholder="Cikk, cikkszám, csoport">
          <span class="halvany" *ngIf="n.cikkek">{{ keszletSzurt(n).length }} cikk · készletérték: {{ n.ertek | number:'1.0-0' }} Ft {{ n.forras?.tavoli ? '· kapcsolaton át' : '· helyben' }}</span>
        </ng-container>
        <ng-container *ngIf="n.ful === 'mozgas'">
          <label>Ettől <input type="date" [(ngModel)]="n.tol"></label>
          <label>Eddig <input type="date" [(ngModel)]="n.ig"></label>
          <button type="button" class="ov-gomb" (click)="keszletBetolt()" [disabled]="n.fut">Lekérés</button>
        </ng-container>
      </div>
      <div class="szn-figy" *ngFor="let f of n.figyelmeztetes || []">{{ f }}</div>
      <div class="szn-hiba" *ngIf="n.hiba">{{ n.hiba }}</div>
      <table class="szn-tabla" *ngIf="n.ful === 'keszlet' && n.cikkek?.length">
        <thead><tr><th>Cikkszám</th><th>Megnevezés</th><th>Csoport</th><th class="j">Készlet</th><th class="j">Átlagár</th><th class="j">Érték</th></tr></thead>
        <tbody>
          <tr *ngFor="let c of keszletSzurt(n)" [class.storno]="false">
            <td class="szam">{{ c.cikkszam }}</td><td>{{ c.nev }}</td><td>{{ c.csoport }}</td>
            <td class="j" [style.color]="c.min_keszlet != null && c.keszlet < c.min_keszlet ? '#b42318' : null">{{ c.keszlet | number:'1.0-3' }} {{ c.egyseg }}</td>
            <td class="j">{{ c.atlagar == null ? '—' : (c.atlagar | number:'1.0-2') + ' Ft' }}</td>
            <td class="j">{{ c.ertek == null ? '—' : (c.ertek | number:'1.0-0') + ' Ft' }}</td>
          </tr>
        </tbody>
      </table>
      <table class="szn-tabla" *ngIf="n.ful === 'mozgas' && n.mozgasok?.length">
        <thead><tr><th>Dátum</th><th>Bizonylat</th><th>Típus</th><th>Raktár</th><th>Partner / számla</th><th class="j">Mennyiség</th><th class="j">Érték</th></tr></thead>
        <tbody>
          <tr *ngFor="let m of n.mozgasok">
            <td>{{ m.datum }}</td><td class="szam">{{ m.bizonylatszam }}</td><td>{{ mozgasTipus(m.tipus) }}</td><td>{{ m.raktar }}</td>
            <td>{{ m.partner }}<small *ngIf="m.szamlaszam"> · {{ m.szamlaszam }}</small></td>
            <td class="j">{{ m.mennyiseg | number:'1.0-3' }}</td><td class="j">{{ m.ertek | number:'1.0-0' }} Ft</td>
          </tr>
        </tbody>
      </table>
      <div class="halvany" *ngIf="(n.ful === 'keszlet' && n.cikkek && !n.cikkek.length) || (n.ful === 'mozgas' && n.mozgasok && !n.mozgasok.length)">Nincs adat.</div>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- PER-ÜGYFÉL MODULOK: mely ügyfélkörös modulok vannak bekapcsolva ennél az ügyfélnél (kapcsolt mód) -->
<ion-modal [isOpen]="modulAblak" (didDismiss)="modulAblak = false" class="bevsor-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Modulok – {{ modulUgyfel?.nev }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="modulAblak = false">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="bv-torzs" style="padding:14px 16px">
      <p class="halvany" style="margin:0 0 12px">Melyik modulokban jelenjen meg ez az ügyfél. A Könyvelés és a Számfejtés mindig elérhető; itt az ügyfélkörös modulok kapcsolhatók ki (pl. ennek az ügyfélnek nem kell Gépjármű vagy Számla és Kassza).</p>
      <label *ngFor="let m of modulLista" style="display:flex;align-items:center;gap:10px;padding:10px 4px;border-top:1px solid var(--ion-color-step-150,#eee);cursor:pointer">
        <input type="checkbox" [(ngModel)]="m.aktiv" style="width:18px;height:18px">
        <span>{{ m.nev }}</span>
      </label>
      <p class="halvany" *ngIf="!modulLista.length" style="padding:10px 4px">Ebben az intézményben nincs ügyfélkörös modul, amit ki lehetne kapcsolni.</p>
      <div style="display:flex;gap:10px;justify-content:flex-end;margin-top:16px">
        <button type="button" class="ov-gomb" (click)="modulAblak = false">Mégse</button>
        <button type="button" class="ov-gomb elsodleges" (click)="modulokMent()" [disabled]="modulMent || !modulLista.length">Mentés</button>
      </div>
    </div>
  </ng-template>
</ion-modal>
